// Accordion script
$(document).on("click", ".ct_collapse summary", function (event) {
  event.preventDefault();

  const $currentAccordion = $(this).closest(".ct_accordion_box");
  const isOpen = $currentAccordion.attr("open") !== undefined;

  $(".ct_accordion_box").not($currentAccordion).removeAttr("open").removeClass("is_open");

  if (isOpen) {
      $currentAccordion.removeAttr("open").removeClass("is_open");
  } else {
      $currentAccordion.attr("open", true).addClass("is_open");
  }
});
// Accordion script End

$(document).ready(function () {
   let selectedShade = $('.ct_o-shade input[type="radio"]:checked').val();
     $('.variant_name_class').text(selectedShade ? `(${selectedShade})` : '');
  
    $(document).on('click change', '.ct_o-shade input[type="radio"]', function () {
        let selectedShade = $('.ct_o-shade input[type="radio"]:checked').val();
        // Ensure the element updates correctly
        $('.variant_name_class').text(selectedShade ? `(${selectedShade})` : '');
    });
  $(document).on('click change', '.card__information .product-form__input.shade input[type="radio"]', function () {
    let selectedShade = $(this).val(); // Get selected variant value
    var variantPrice =  $(this).attr('data-variant_price');
    //console.log(variantPrice,"::variantPrice");
    let $parentCard = $(this).closest('.card__information'); // Find closest product card context
    let $parentCard_price = $(this).closest('.card__content ');
    
    // Update only the related variant name inside the same product card
    $parentCard.find('.variant_name_list_class').text("(" + selectedShade + ")");
     $parentCard_price.find('.card_product_price_class').text(variantPrice);
  });
});




// Eye Icon show hide script start
document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".field").forEach(field => {
    const passwordInput = field.querySelector("input[type='password'], input[type='text']");
    const [closeEye, openEye] = field.querySelectorAll(".eye-icon");
    
    if (passwordInput && closeEye && openEye) {
      [closeEye, openEye].forEach(icon => {
        icon.addEventListener("click", () => {
          const isHidden = passwordInput.type === "password";
          passwordInput.type = isHidden ? "text" : "password";
          closeEye.style.display = isHidden ? "none" : "inline-block";
          openEye.style.display = isHidden ? "inline-block" : "none";
        });
      });
    }
  });
});
// Eye Icon show hide script End

jQuery(document).on("click","#orderTrackingForm .trackorder",function(e){
  e.preventDefault();
  //let orderId=jQuery("#trackingNumber").val();
  let orderId="1019";  
  let emailId=jQuery("#my_account_input_email_id").val();
  let getToken=generateToken();
  // let geturl=trackingOrders(getToken, orderId);
  // if(geturl)
  // {
  //   window.location.href=geturl
  // }
  
  
})
function generateToken()
  {
    let data={
      "method_call":"getTracking"
    }
    
    var settings = {
      "url": "http://localhost/tracking/index.php",
      "method": "POST",
      "data":data,
      "dataType": "json",
      "success": function (responseData) {
        console.log(responseData);
      }
    };
    
    $.ajax(settings).done(function (response) {
      return response
    });
  }
function trackingOrders(token, orderId)
  {

    var settings = {
        "url": "https://apiv2.shiprocket.in/v1/external/courier/track?order_id=1018&channel_id=6279690",
        "method": "GET",
        "timeout": 0,
        "headers": {
          "Authorization": "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOjU5NDgyMDYsInNvdXJjZSI6InNyLWF1dGgtaW50IiwiZXhwIjoxNzQxODY4Njc5LCJqdGkiOiJUdWNpUEs5dGtraktzWWNBIiwiaWF0IjoxNzQxMDA0Njc5LCJpc3MiOiJodHRwczovL3NyLWF1dGguc2hpcHJvY2tldC5pbi9hdXRob3JpemUvdXNlciIsIm5iZiI6MTc0MTAwNDY3OSwiY2lkIjo0NDY0NjI3LCJ0YyI6MzYwLCJ2ZXJib3NlIjpmYWxzZSwidmVuZG9yX2lkIjowLCJ2ZW5kb3JfY29kZSI6IiJ9.EycWPSYeYj7s83x6riGoH8eae9K5LvvmTUlkWhHrRHI"
        },
      };
      
      $.ajax(settings).done(function (response) {
        console.log(response);
      });
    // var settings = {
    //   "url": `https://apiv2.shiprocket.in/v1/external/courier/track?order_id=${orderId}&channel_id=6279690`,
    //   "method": "GET",
    //   "timeout": 0,
    //   "headers": {
    //     "Authorization": `Bearer ${token}`
    //   },
    // };
    
    // $.ajax(settings).done(function (response) {
    //   console.log(response);
    // });

  }


$(document).ready(function () {
    $('a[href="#ct_ContactFooter-main"]').on('click', function (e) {
        e.preventDefault(); // Prevent default anchor behavior
        var target = $('#ct_ContactFooter-main');

        if (target.length) {
            $('html, body').animate({
                scrollTop: target.offset().top
            }, 800); // Adjust the duration as needed
        }
    });
});

$(document).ready(function () {
    $('#ctOgift').on('change', function () {
        if ($(this).is(':checked')) {
            $('.ct-offers-gift-wrapping-content').slideDown();
        } else {
            $('.ct-offers-gift-wrapping-content').slideUp();
            $('.ct-offers-gift-wrapping-text').val('');
            $('.custome_field_textarea').val('');
        }
    });
    $('.ct-offers-gift-wrapping-text').on('input', function () {
          $('.custome_field_textarea').val($(this).val());
    });
});

$(document).ready(function () {
  // Open popup
  $(document).on('click', '.rh-gift-popup-label', function (e) {
    e.preventDefault();
    $('.rh-gift-popup-input').val($('.rh-gift-popup-hidden-note').val());
    $('.rh-gift-popup-overlay').fadeIn();
  });

  // Submit
  $(document).on('click', '.rh-gift-popup-submit', function () {
    var message = $.trim($('.rh-gift-popup-input').val());
    
    $('.rh-gift-popup-hidden-note').val(message);
    $('.rh-gift-popup-checkbox').prop('checked', message.length > 0);
    
    $('.rh-gift-popup-overlay').fadeOut();
  });

  // Close with X button
  $(document).on('click', '.rh-gift-popup-close', function () {
    $('.rh-gift-popup-overlay').fadeOut();
  });

  // Close when clicking outside the popup box
  $(document).on('click', '.rh-gift-popup-overlay', function (e) {
    if (e.target === this) {
      $('.rh-gift-popup-overlay').fadeOut();
    }
  });
});